// extracted by mini-css-extract-plugin
module.exports = {"container":"LanguageSelector-module--container--3a6pT","selector":"LanguageSelector-module--selector--2JoYJ","language":"LanguageSelector-module--language--1TRsF"};